import React, { useState } from 'react';

import { ColorPicker, useColor } from "react-color-palette";
import "react-color-palette/lib/css/styles.css";
import Switch from '@mui/material/Switch';
import Cookies from 'universal-cookie';
import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';

export function getLighterColor(originalColor, percentLighter) {
    // Ensure the percentLighter is between 0 and 100
    percentLighter = Math.min(100, Math.max(0, percentLighter));
  
    // Convert the hexadecimal color to RGB
    let r = parseInt(originalColor.substring(1, 3), 16);
    let g = parseInt(originalColor.substring(3, 5), 16);
    let b = parseInt(originalColor.substring(5, 7), 16);
  
    // Calculate the new RGB values for a lighter color
    r = Math.round(r + (255 - r) * (percentLighter / 100));
    g = Math.round(g + (255 - g) * (percentLighter / 100));
    b = Math.round(b + (255 - b) * (percentLighter / 100));
  
    // Convert the new RGB values back to hexadecimal format
    const lighterColor = `#${(1 << 24 | r << 16 | g << 8 | b).toString(16).slice(1)}`;
  
    return lighterColor;
}
export function rgbToHex(rgbString) {
    // Extract the RGB values using a regular expression
    const rgbValues = rgbString.match(/\d+/g);
  
    // Ensure three values are present (for red, green, and blue)
    if (rgbValues.length !== 3) {
      throw new Error("Invalid RGB string");
    }
  
    // Convert each RGB value to hexadecimal and concatenate them
    const hexColor = rgbValues
      .map(value => {
        const hex = parseInt(value, 10).toString(16);
        return hex.length === 1 ? "0" + hex : hex;
      })
      .join("");
  
    // Prepend the hexadecimal color with a hash symbol
    return `#${hexColor}`;
  }
  
function useForceUpdate(){
    const [value, setValue] = React.useState(0); // integer state
    if(false){
        console.log(value)
    }
    return () => setValue(value => value + 1); // update the state to force render
}

export const increase_brightness = function(color,percent){

    var ctx = document.createElement('canvas').getContext('2d');

    ctx.fillStyle = color;
    ctx.fillRect(0,0,1,1);

    color = ctx.getImageData(0,0,1,1);
    var r = color.data[0] + Math.floor( percent / 100 * 255 );
    var g = color.data[1] + Math.floor( percent / 100 * 255 );
    var b = color.data[2] + Math.floor( percent / 100 * 255 );

    return 'rgb('+r+','+g+','+b+')';
}

export const CustomizationPage = () => {
    const updateComponent = useForceUpdate()
    const cookies = new Cookies();
 
    /// update CSS
    var ambientColor = localStorage.getItem('ambientColor')  ? localStorage.getItem('ambientColor') : "rgb(0, 166, 178)"
    var fontColorLocal = cookies.get('fontColor')  ? localStorage.getItem('ambientColor') : "rgb(0, 0, 0)"
    var r = document.querySelector(':root');
    var reverse = cookies.get('nightmode')==='false' ? false : true
    if(!reverse){
        r.style.setProperty('--container-shadow-color', increase_brightness(ambientColor,-10));
        r.style.setProperty('--container-shadow-color-hover', ambientColor);
        r.style.setProperty('--container-shadow-color-hover-lighter', increase_brightness(ambientColor,10));    
        r.style.setProperty('--container-shadow-color-hover-more-lighter', increase_brightness(ambientColor,95));    
        r.style.setProperty('--top-bg-color', ambientColor);
        r.style.setProperty('--hamburger-icon-hover-color', increase_brightness(ambientColor,-10));
        r.style.setProperty('--menu-item-hover-color', 'white');
        r.style.setProperty('--menu-item-hover-font-color', 'black');
        r.style.setProperty('--font-color', 'white');
        r.style.setProperty('--sidebar-bg-color', ambientColor);
    }
    else{
        var backgroundColor = 'rgb(252,252,252)'
        r.style.setProperty('--container-shadow-color', increase_brightness(backgroundColor,-10));
        r.style.setProperty('--container-shadow-color-hover', backgroundColor);
        r.style.setProperty('--container-shadow-color-hover-lighter', increase_brightness(backgroundColor,10));     
        r.style.setProperty('--container-shadow-color-hover-more-lighter', increase_brightness(backgroundColor,0));    
        r.style.setProperty('--top-bg-color', backgroundColor);
        r.style.setProperty('--hamburger-icon-hover-color', increase_brightness(backgroundColor,-10));
        r.style.setProperty('--menu-item-hover-color', ambientColor);
        r.style.setProperty('--menu-item-hover-font-color', 'white');
        r.style.setProperty('--font-color', 'rgb(50,50,50)');
        r.style.setProperty('--sidebar-bg-color', backgroundColor);
    }
    
    const BootstrapButton = styled(Button)({
        ":disabled":{
            color:'rgb(150,150,150)',
            backgroundColor: increase_brightness(ambientColor,-50),
        },
        color:'white',
        backgroundColor: ambientColor,
        '&:hover': {
          backgroundColor: increase_brightness(ambientColor,-10),
          borderColor: increase_brightness(ambientColor,-20),
          boxShadow: 'none',
        },
        '&:active': {
          boxShadow: 'none',
          backgroundColor: increase_brightness(ambientColor,10),
          borderColor: increase_brightness(ambientColor,-10),
        },
    });

    const [showAmbientColor, setShowAmbientColor] = useState(false)
    const [showFontColor, setShowFontColor] = useState(false)
    const [newSidebar, setNewSidebar] = useState(cookies.get('newSidebar')==='true' ? true : false)
    const [color, setColor] = useColor("hex", ambientColor);
    const [fontColor, setFontColor] = useColor("hex", fontColorLocal);
    const changeSidebar = () => {
        if(cookies.get('newSidebar')==='true'){
            cookies.set('newSidebar',false)
            setNewSidebar(false);
        }
        else{
            cookies.set('newSidebar',true);
            setNewSidebar(true);
        }
        window.location.reload();
    }
    return (  
        <>
            {/* <div style={{display:"flex",height:"8%",alignItems:'center'}}>
                <div style={{width:"95%",display:'flex',justifyContent:'center',paddingLeft:"2%",fontSize:"15px",fontWeight:"500",userSelect:'none',height:'10%'}}>Custom Page Color</div>
            </div>           */}
            <div className='getLogsContainer'  onDrag={updateComponent}>
                
                {/* <div style={{display:'flex',alignItems:'center'}}>
                    <div style={{paddingTop:"2%",paddingLeft:'2%',display:'flex',alignItems:'center',fontSize:'13px'}}>
                        New Sidebar
                    </div>
                    <div style={{transform:'scale(0.7)',paddingTop:"2%",paddingLeft:'2%'}}><Switch checked={newSidebar} onChange={(e)=>{changeSidebar(e)}}/></div>
                </div> */}

                {/* <div style={{display:'flex',alignItems:'center'}}>
                    <div style={{paddingTop:"2%",paddingLeft:'2%',display:'flex',alignItems:'center',fontSize:'13px'}}>
                        New Sidebar Hover Menu
                    </div>
                    <div style={{transform:'scale(0.7)',paddingTop:"2%",paddingLeft:'2%'}}><Switch checked={localStorage.getItem("hoverSidebarItem") ? true : false} onChange={(e)=>{if(e.target.checked){localStorage.setItem('hoverSidebarItem',true)}else{localStorage.removeItem('hoverSidebarItem')};updateComponent(e)}}/></div>
                </div> */}

                <div style={{display:'flex',alignItems:'center'}}>
                    <div style={{paddingTop:"2%",paddingLeft:'2%',display:'flex',alignItems:'center',fontSize:'13px'}}>
                        Ambient Color
                    </div>
                    <div style={{height:'20px',marginLeft:'2%',marginTop:'20px',width:'50px',background:ambientColor}} onClick={()=>{setShowAmbientColor(true)}}>

                    </div>
                </div>
                {/* <div style={{display:'flex',alignItems:'center'}}>
                    <div style={{paddingTop:"2%",paddingLeft:'2%',display:'flex',alignItems:'center',fontSize:'13px'}}>
                        Font Color
                    </div>
                    <div  style={{height:'20px',marginLeft:'2%',marginTop:'20px',width:'50px',background:fontColor}} onClick={()=>{setShowFontColor(true)}}>

                    </div>
                </div> */}
                <div style={{transform:'scale(0.7)',marginTop:'10%',marginLeft:'10%'}}>
                    <BootstrapButton onClick={()=>{
                        localStorage.setItem('ambientColor', rgbToHex("rgb(0, 166, 178)"));
                        document.querySelector(':root').style.setProperty('--ambient-color', rgbToHex("rgb(0, 166, 178)"));
                        document.querySelector(':root').style.setProperty('--ambient-color-10-percent-lighter', '#1aafba');
                        document.querySelector(':root').style.setProperty('--ambient-color-20-percent-lighter', '#33b8c1');
                        document.querySelector(':root').style.setProperty('--ambient-color-30-percent-lighter', '#4dc1c9');
                        document.querySelector(':root').style.setProperty('--ambient-color-40-percent-lighter', '#66cad1');
                        document.querySelector(':root').style.setProperty('--ambient-color-50-percent-lighter', '#80d3d9');
                        document.querySelector(':root').style.setProperty('--ambient-color-60-percent-lighter', '#99dbe0');
                        document.querySelector(':root').style.setProperty('--ambient-color-70-percent-lighter', '#b3e4e8');
                        document.querySelector(':root').style.setProperty('--ambient-color-80-percent-lighter', '#ccedf0');
                        document.querySelector(':root').style.setProperty('--ambient-color-90-percent-lighter', '#e6f6f7');
                        document.querySelector(':root').style.setProperty('--ambient-color-95-percent-lighter', '#f2fbfb');
                        window.location.reload();
                    }}> Reset to Default</BootstrapButton>
                </div>

                {
                    showAmbientColor && 
                        <div onMouseLeave={()=>{setShowAmbientColor(false)}} onBlur={()=>{setShowAmbientColor(false)}}>
                            <ColorPicker width={456} height={228} 
                            color={color} 
                            onChange={(e)=>{
                                setColor(e);localStorage.setItem('ambientColor',e.hex);
                                document.querySelector(':root').style.setProperty('--ambient-color', e.hex);
                                document.querySelector(':root').style.setProperty('--ambient-color-10-percent-lighter', getLighterColor(e.hex,10));
                                document.querySelector(':root').style.setProperty('--ambient-color-20-percent-lighter', getLighterColor(e.hex,20));
                                document.querySelector(':root').style.setProperty('--ambient-color-30-percent-lighter', getLighterColor(e.hex,30));
                                document.querySelector(':root').style.setProperty('--ambient-color-40-percent-lighter', getLighterColor(e.hex,40));
                                document.querySelector(':root').style.setProperty('--ambient-color-50-percent-lighter', getLighterColor(e.hex,50));
                                document.querySelector(':root').style.setProperty('--ambient-color-60-percent-lighter', getLighterColor(e.hex,60));
                                document.querySelector(':root').style.setProperty('--ambient-color-70-percent-lighter', getLighterColor(e.hex,70));
                                document.querySelector(':root').style.setProperty('--ambient-color-80-percent-lighter', getLighterColor(e.hex,80));
                                document.querySelector(':root').style.setProperty('--ambient-color-90-percent-lighter', getLighterColor(e.hex,90));
                                document.querySelector(':root').style.setProperty('--ambient-color-95-percent-lighter', getLighterColor(e.hex,95));
                            }}
                            hideHSV dark 
                            />
                        </div>
                }
                {
                    showFontColor && 
                        <div onMouseLeave={()=>{setShowFontColor(false)}} onBlur={()=>{setShowFontColor(false)}}>

                            <ColorPicker width={456} height={228} 
                                color={fontColor} 
                                onChange={(e)=>{setFontColor(e);localStorage.setItem('fontColor',e.hex)}} hideHSV dark 
                                />
                        </div>

                }
            </div>
        </>  
    )
}

export default CustomizationPage;
